/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import Swal from "sweetalert2";

import tcleService from "../../api/atendimentos/tcleService";
import { formataDataExibicao, formataDataHoraExibicao } from "../../common/utils";

class TcleLinhaCuidado extends Component {
    constructor(props) {
        super(props);

        this.state = { loading: true, enviando: false, erro: "", dados: null, canal: "ambos" };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiroValor = Object.values(data)[0];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, dados: null });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await tcleService.obter(atendimentoId);
            const dados = response.data || null;

            this.setState({ loading: false, dados, canal: dados?.canal_padrao || "ambos" });
        } catch (error) {
            console.error("Erro ao carregar TCLE:", error);
            this.setState({ loading: false, erro: this.getMensagemErro(error, "Não foi possível carregar o TCLE.") });
        }
    };

    enviar = async () => {
        const { atendimentoId } = this.props;
        const { canal, dados } = this.state;

        const rotuloCanal = dados?.canais_disponiveis?.find((c) => c.value === canal)?.label || canal;

        const confirmacao = await Swal.fire({
            title: "Reenviar TCLE?",
            text: `O termo será reenviado ao paciente por ${rotuloCanal}.`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, reenviar",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        this.setState({ enviando: true });

        try {
            const resposta = await tcleService.enviar(atendimentoId, canal);
            this.setState({ enviando: false });
            await this.carregar();
            Swal.fire("Sucesso", (resposta.data?.mensagens || []).join(" ") || "TCLE reenviado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao reenviar TCLE:", error);
            this.setState({ enviando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível reenviar o TCLE."), "error");
        }
    };

    renderSituacao = () => {
        const { dados } = this.state;
        const aceite = dados?.aceite || {};
        const automatico = dados?.envio_automatico || {};

        return (
            <Row className="mb-3">
                <Col sm={6} lg={3} className="mb-2">
                    <small className="text-muted d-block">Situação</small>
                    <Badge bg={aceite.assinado ? "success" : "warning"}>
                        {aceite.assinado ? "Assinado" : "Aguardando assinatura"}
                    </Badge>
                </Col>
                <Col sm={6} lg={3} className="mb-2">
                    <small className="text-muted d-block">Data do aceite</small>
                    <span>{aceite.data_aceite ? formataDataHoraExibicao(aceite.data_aceite) : "-"}</span>
                </Col>
                <Col sm={6} lg={3} className="mb-2">
                    <small className="text-muted d-block">Versão vigente</small>
                    <span>{aceite.versao || "-"}</span>
                </Col>
                <Col sm={6} lg={3} className="mb-2">
                    <small className="text-muted d-block">Envio automático</small>
                    <span>
                        {automatico.enviado_em
                            ? `${formataDataHoraExibicao(automatico.enviado_em)} (${automatico.canal_display})`
                            : "Não enviado"}
                    </span>
                </Col>
            </Row>
        );
    };

    renderHistorico = () => {
        const { dados } = this.state;
        const historico = dados?.historico_versoes || [];

        return (
            <>
                <h6 className="mt-4 mb-2">Histórico de versões</h6>
                <Table responsive className="custom-table table-sm align-middle mb-0">
                    <thead>
                        <tr>
                            <th>Versão</th>
                            <th>Situação</th>
                            <th>Data de assinatura</th>
                            <th>Documento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historico.length === 0 ? (
                            <tr>
                                <td colSpan={4} className="text-center">
                                    Nenhuma versão registrada.
                                </td>
                            </tr>
                        ) : (
                            historico.map((versao) => (
                                <tr key={versao.id}>
                                    <td>{versao.termo_versao || "-"}</td>
                                    <td>
                                        <Badge bg={versao.assinado ? "success" : "secondary"}>
                                            {versao.assinado ? "Assinado" : "Pendente"}
                                        </Badge>
                                    </td>
                                    <td>{versao.data_assinatura ? formataDataExibicao(versao.data_assinatura) : "-"}</td>
                                    <td>
                                        {versao.termo_pdf_assinado_url && (
                                            <>
                                                <a href={versao.termo_pdf_assinado_url} target="_blank" rel="noreferrer">
                                                    Visualizar assinado
                                                </a>
                                                <a
                                                    href={versao.termo_pdf_assinado_url}
                                                    download
                                                    className="ms-3"
                                                >
                                                    Download
                                                </a>
                                            </>
                                        )}
                                        {!versao.termo_pdf_assinado_url && versao.termo_pdf_url && (
                                            <a href={versao.termo_pdf_url} target="_blank" rel="noreferrer">
                                                Visualizar termo
                                            </a>
                                        )}
                                        {!versao.termo_pdf_assinado_url && !versao.termo_pdf_url && "-"}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </>
        );
    };

    render() {
        const { podeEditar } = this.props;
        const { loading, erro, dados, canal, enviando } = this.state;

        if (loading) {
            return (
                <Card className="cardDestaque mt-4">
                    <Card.Body className="text-center">
                        <Spinner animation="border" size="sm" />
                    </Card.Body>
                </Card>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        if (!dados) {
            return null;
        }

        const semContato = !dados.paciente_tem_email && !dados.paciente_tem_celular;

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <h5 className="mb-1">TCLE</h5>
                    <small className="text-muted d-block mb-3">
                        Enviado automaticamente ao paciente na inclusão na Linha de Cuidado.
                    </small>

                    {this.renderSituacao()}

                    {semContato && (
                        <Alert variant="warning">
                            O paciente não possui e-mail nem celular cadastrado — não é possível enviar o TCLE.
                        </Alert>
                    )}

                    {podeEditar && !semContato && (
                        <Row className="align-items-end">
                            <Col sm={6} lg={4} className="mb-2">
                                <Form.Label>Canal de envio</Form.Label>
                                <Form.Select value={canal} onChange={(event) => this.setState({ canal: event.target.value })}>
                                    {(dados.canais_disponiveis || []).map((opcao) => (
                                        <option
                                            key={opcao.value}
                                            value={opcao.value}
                                            disabled={
                                                (opcao.value === "email" && !dados.paciente_tem_email) ||
                                                (opcao.value === "whatsapp" && !dados.paciente_tem_celular)
                                            }
                                        >
                                            {opcao.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col sm={6} lg={4} className="mb-2">
                                <Button variant="outline-primary" onClick={this.enviar} disabled={enviando}>
                                    {enviando ? "Enviando..." : "Reenviar TCLE"}
                                </Button>
                            </Col>
                        </Row>
                    )}

                    {this.renderHistorico()}
                </Card.Body>
            </Card>
        );
    }
}

export default TcleLinhaCuidado;
